// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import Core from '@/until/core'

Vue.use(Vuex)

Vue.config.productionTip = false
const store = new Vuex.Store({
    state: {
        appMessage: '',
        appLoaderShow: null,
        sourceRoute: null,
        scrollBottom: 0,
        routerParams: {
            Uid: 0,
            ShareCode: 0
        },
        staffData: null
    },
    mutations: {
        onChangeAppMessage (state, value) {
            state.appMessage = value
        },
        onChangeAppLoaderShow (state, value) {
            state.appLoaderShow = value
        }
    }
})

// 进入页面前
router.beforeEach((route, redirect, next) => {
    // console.log('beforeEach', route, redirect)
    store.commit('onChangeAppLoaderShow', '玩命加载中, 请稍候...')
    const authUrl = Core.setAuthUrl(null, false)
    if (!authUrl) {
        const url = window.location.href.split('#')[0]
        Core.setAuthUrl(url, true)
    }
    Core.use('router', {route: route, redirect: redirect})
    localStorage.setItem('cacheSourceRoute', redirect.fullPath)
    Core.ready(next)
})
// 进入页面后
router.afterEach((route) => {
    // console.log('to', route)
    const Options = Core.getOptions()
    window.document.title = Options.WEB_APP_TITLE || '\u200E' // 设置标题为空
    store.commit('onChangeAppLoaderShow', false)
    localStorage.removeItem('cacheSourceRoute')
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js